
export default {
  name: 'WeUIToast',
  components: {
    lazyWxDownloadReminder: () => import('./lazy-wx-download-reminder.vue'),
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show: true,
      text_class_name: '',
      icon_class_name: '',
    };
  },
  beforeMount() {
    switch (this.type) {
      case 'textMore':
        this.text_class_name = 'weui-toast_text-more';
        break;
      case 'text':
        this.text_class_name = 'weui-toast_text';
        break;
      case 'circle':
        this.text_class_name = 'weui-toast_circle';
        break;
      default:
        break;
    }
    switch (this.type) {
      case 'success':
        this.icon_class_name = 'weui-icon-success-no-circle';
        break;
      case 'textMore':
        this.icon_class_name = 'weui-icon-warn';
        break;
      case 'warn':
        this.icon_class_name = 'weui-icon-warn';
        break;
      default:
        break;
    }
  },
  methods: {
    close() {
      this.show = false;
      setTimeout(() => {
        this.$el.remove();
      }, 300);
    },
  },
};
